import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
import type { HTMLAttributes } from 'react';
export type FormFieldProps = {
  children: React.ReactNode | React.ReactNode[];
  variant?: 'vertical' | 'horizontal' | 'horizontal-justify-between';
  fullWidth?: boolean;
} & HTMLAttributes<HTMLDivElement>;
const FormField = t0 => {
  const $ = _c(20);
  let children;
  let className;
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    const {
      children: t3,
      variant: t4,
      className: t5,
      id,
      fullWidth: t6,
      ...t7
    } = t0;
    children = t3;
    t1 = t4;
    className = t5;
    t2 = t6;
    props = t7;
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
    $[4] = t1;
    $[5] = t2;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
    t1 = $[4];
    t2 = $[5];
  }
  const variant = t1 === undefined ? "vertical" : t1;
  const fullWidth = t2 === undefined ? false : t2;
  if (variant === "horizontal" || variant === "horizontal-justify-between") {
    let t3;
    if ($[6] !== className || $[7] !== fullWidth) {
      t3 = cx("flex gap-2 justify-between items-center", className, {
        "w-full": fullWidth
      });
      $[6] = className;
      $[7] = fullWidth;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    let t4;
    if ($[9] !== children || $[10] !== props || $[11] !== t3) {
      t4 = <div className={t3} {...props}>{children}</div>;
      $[9] = children;
      $[10] = props;
      $[11] = t3;
      $[12] = t4;
    } else {
      t4 = $[12];
    }
    return t4;
  }
  let t3;
  if ($[13] !== className || $[14] !== fullWidth) {
    t3 = cx("flex flex-col gap-2", className, {
      "w-full": fullWidth
    });
    $[13] = className;
    $[14] = fullWidth;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  let t4;
  if ($[16] !== children || $[17] !== props || $[18] !== t3) {
    t4 = <div className={t3} {...props}>{children}</div>;
    $[16] = children;
    $[17] = props;
    $[18] = t3;
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  return t4;
};
export default FormField;